export const ISSUE_TRACK_TOOLTIP =
  'Track this issue to surface updates the next time this agent runs.'

export const ISSUE_UNTRACK_TOOLTIP =
  'Stop tracking to stop receiving updates for this issue.'

// Keep trend-detection primary actions aligned with the antd app primary
// without changing shared tokens repo-wide.
export const TREND_DETECTION_PRIMARY_BLUE = '#4070c0'

export const AGENT_HOW_IT_WORKS_TEXT =
  "The Issue Agent monitors new feedback for meaningful spikes and emerging patterns, automatically flagging issues and investigating what's driving them."

export const AGENT_ANALYSIS_WINDOW_LABEL = 'Analysis window'

export const AGENT_ANALYSIS_WINDOW_VALUE =
  'Most recent full week vs. prior 6 weeks'

export const AGENT_ANALYSIS_WINDOW_HELPER_TEXT =
  'Daily update hubs use day-based windows instead.'

export const BENCHMARKING_ANALYSIS_WINDOW_VALUE = 'Last 3 months (rolling)'

export const BENCHMARKING_ANALYSIS_WINDOW_HELPER_TEXT =
  'Runs weekly, analyzing the most recent 3 months of feedback.'

export const AGENT_DESCRIPTION_LABEL = 'What should this agent monitor?'

export const AGENT_DESCRIPTION_HELPER_TEXT =
  "Describe the issues, themes, or signals to watch for (you don't need to include date ranges)."

export const AGENT_DESCRIPTION_PLACEHOLDER =
  'Find issues with my products across all my datasets.'

export const AGENT_DESCRIPTION_TIME_RANGE_WARNING =
  'Your description includes a date range. Yogi handles the time window automatically.'

const AGENT_DESCRIPTION_TIME_RANGE_PATTERN =
  /\b(?:past|last|previous)\s+(?:\d+\s+)?(?:day|days|week|weeks|month|months|quarter|quarters|year|years)\b|\b(?:january|february|march|april|may|june|july|august|september|october|november|december)\s+\d{4}\b|\b\d{4}-\d{2}-\d{2}\b|\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/i

export function containsAgentDescriptionTimeRange(value: string): boolean {
  return AGENT_DESCRIPTION_TIME_RANGE_PATTERN.test(value)
}

/** Issue agent sensitivity options shared between create wizard, edit panel,
 * and Yogi-staff admin modal. `volumeDots` is consumed by the create
 * wizard's cards only (intensity meter next to each card). */
export const SENSITIVITY_OPTIONS = [
  {
    value: 'early_signals',
    label: 'Early signals',
    tooltip: 'Issues starting to rise above their usual level',
    volumeDots: 3,
  },
  {
    value: 'meaningful_trends',
    label: 'Meaningful trends',
    tooltip: 'Issues clearly building vs. their normal volume',
    volumeDots: 2,
  },
  {
    value: 'major_spikes_only',
    label: 'Major spikes only',
    tooltip: 'Issues far above their normal level',
    volumeDots: 1,
  },
] as const

export const SENSITIVITY_HELPER_TEXT =
  'Yogi compares issue volume now vs. its usual level. Each setting raises the bar for what gets flagged.'
